module.exports = __webpack_public_path__ + "img/image_06.66dfb309.png";